<template>
    <transition
        enter-active-class="fadeInDown"
        leave-active-class="fadeOutUp"
    >
        <div v-if="alert" :key="alert" id="alertWarning" class="text-center" @click="$store.commit('shared/setAlert',null)" >
            <h1 class="alertText" v-html="alert"></h1>
        </div>
    </transition>
</template>

<script>
    export default {
        name: "Alert",
        data(){
            return {
                timeout: null
            }
        },
        computed: {
            alert() {
                return this.$store.state.shared.alert;
            }
        },
        watch: {
            alert(val) {
                if (val) {
                    if(!val.includes("<button")){
                        clearTimeout(this.timeout);
                        this.timeout = setTimeout(() => {
                            this.$store.commit("shared/setAlert",null);
                        }, 5000);
                    }
                }
            }
        }
    }
</script>
